import Script from 'next/script'

const GTM_ID =
  process.env.APP_ENV !== 'production' ? 'GTM-56MWNNX' : 'GTM-TLW9XW3'

interface ConversionTrackingProps {
  enabled?: boolean
}

/**
 * GTM loader for sign-up funnel pages.
 * The marketing pixels (Meta, TikTok, Microsoft UET) are consent-gated and
 * injected by utilities/tracking-consent.ts — never rendered here.
 * Only renders when enabled prop is true.
 */
export default function ConversionTracking({
  enabled = true,
}: ConversionTrackingProps) {
  if (!enabled) {
    return null
  }

  return (
    <>
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ APP_ENV: '${process.env.APP_ENV}' })
            `,
        }}
      />
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer', '${GTM_ID}');
              `,
        }}
      />
      <noscript>
        <iframe
          title="GTM"
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}
